import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Translation, TranslocoLoader } from '@jsverse/transloco';
import { lastValueFrom } from 'rxjs';
import { UserService } from '../services/user.service';
import { withCache } from '@ngneat/cashew';
import { TranslocoCacheTime } from './transloco-cache.const';

@Injectable({ providedIn: 'root' })
export class TranslocoHttpLoader implements TranslocoLoader {
    constructor(
        private httpClient: HttpClient,
        private userService: UserService,
    ) {}

    async getTranslation(lang: string): Promise<Translation> {
        let language, module;
        if (lang.includes('/')) {
            [module, language] = lang.split('/');
        } else {
            language = lang;
            module = 'page';
        }
        // for ttl use TranslocoCacheTime, because this const will be used for clearing the cache in case of changes
        if (module === 'codext') {
            const result = await lastValueFrom(
                this.httpClient.get<Translation>(
                    `/assets/i18n/${language}.json`,
                    {
                        // context: withCache({
                        //     ttl: TranslocoCacheTime,
                        // }),
                    }
                )
            );

            return result;
        } else {
            const uid = this.userService?.user?.uid;
            const baseUrl = `hippo/navigator.php?page=pages/system/System_translations.php&page_type=json${
                uid ? `&uid=${uid}` : ''
            }`;

            const formData = new FormData();
            formData.append('iso_code', language);
            formData.append('module', module);
            // for ttl use TranslocoCacheTime, because this const will be used for clearing the cache in case of changes
            try {
                const { result } = await lastValueFrom(
                    this.httpClient.post<Translation>(baseUrl, formData, {
                        context: withCache({
                            ttl: TranslocoCacheTime,
                            key: `translate-${module}-${language}`,
                        }),
                    })
                );
                return result;
            } catch (error) {
                return null;
            }
        }
    }
}
